import useValidateBots from "@shared/features/bots/BotForm/common/useValidateBots";
import useBulkActionAccountsOverlapData from "@shared/features/bots/BotForm/common/hooks/useBulkActionAccountsOverlapData";
import { useContext } from "react";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { isSymbol } from "@shared/types/utils";
import { Error } from "@shared/features/bots/BotForm/common/types";
import { CreateBotRequest } from "@shared/types";

const useBulkCreateBotsForm = () => {
  const {
    getExchangeToSymbolPricesStatus,
    getParsedFormData: baseGetParsedFormData,
  } = useContext(BotFormContext)!;
  const exchangeToSymbolPrices = getExchangeToSymbolPricesStatus.data;
  const { accountsOverlapData } = useBulkActionAccountsOverlapData({});

  const {
    bulkActionBotsData,
    bulkActionInvalidBotsData,
    bulkActionValidBotsData,
  } = useValidateBots({
    exchangeToSymbolPrices,
  });

  const getParsedFormData = (
    ignoreErrors?: Error[]
  ): CreateBotRequest | undefined => {
    const baseData = baseGetParsedFormData(ignoreErrors);
    if (!baseData) return;
    const validAccountIds = new Set(
      bulkActionValidBotsData
        ?.map((bot) => {
          const botAccount = bot.validationData.parsedData?.account;
          return isSymbol(botAccount) ? undefined : botAccount?.client_id;
        })
        .filter((accountId) => !!accountId) as number[]
    );
    const formAccountIds = Array.isArray(baseData?.account_ids)
      ? baseData?.account_ids
      : undefined;
    return {
      ...baseData,
      account_ids:
        formAccountIds?.filter((accountId) => validAccountIds.has(accountId)) ||
        [],
    };
  };

  return {
    bulkActionBotsData,
    bulkActionInvalidBotsData,
    bulkActionValidBotsData,
    accountsOverlapData,
    getParsedFormData,
  };
};

export default useBulkCreateBotsForm;
